//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

export const ReportFieldType = {
    /** The field is one of the properties of the entity */
    Property: 0,

    /** The field is one of the attributes of the entity */
    Attribute: 1,

    /** The field(s) that result from a DataSelectComponent */
    DataSelectComponent: 2
} as const;

export const ReportFieldTypeDescription: Record<number, string> = {
    0: "Property",

    1: "Attribute",

    2: "Data Select Component"
};

export type ReportFieldType = typeof ReportFieldType[keyof typeof ReportFieldType];
